/**
 * wagbappro.id 印尼语首页内容
 */
import siteConfig from '@/config/site';

const img = (name) => require(`@/assets/wagbappro/${name}`);

const statIcon = (paths) =>
  `<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">${paths}</svg>`;

export const hero = {
  h1: 'Unduh GB WhatsApp Terbaru 2026',
  subtitle: 'GB WhatsApp APK v21.30 Anti-Ban',
  description:
    'Download GB WhatsApp APK v21.30 Anti-Ban terbaru 2026 dengan fitur lengkap, privasi lebih aman, dan bebas blokir.',
  cta: 'Unduh WA GB APK v21.30 Sekarang',
  ctaLink: '/unduh-gb-wa/',
  logo: siteConfig.logo,
  card: {
    title: 'WA GB Terbaru 2026',
    description:
      'Download GB WhatsApp APK v21.30 Anti-Ban terbaru 2026 dengan fitur lengkap, privasi lebih aman, dan bebas blokir.',
    cta: 'Download GB WhatsApp APK',
    stats: [
      {
        label: 'Versi',
        value: 'v21.30',
        icon: statIcon(
          '<path fill="currentColor" d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82zM7 7h.01"/>',
        ),
      },
      {
        label: 'Ukuran',
        value: '±50MB',
        icon: statIcon(
          '<path fill="currentColor" d="M12 3a1 1 0 0 1 1 1v9.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 13.586V4a1 1 0 0 1 1-1z"/><path fill="currentColor" d="M4 18a1 1 0 0 1 1-1h14a1 1 0 0 1 0 2H5a1 1 0 0 1-1-1z"/>',
        ),
      },
      {
        label: 'Android',
        value: '5.0+',
        icon: statIcon(
          '<path fill="currentColor" d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85a.637.637 0 0 0-.83.22l-1.88 3.24a11.43 11.43 0 0 0-8.94 0L5.65 5.67a.643.643 0 0 0-.87-.2c-.28.18-.37.54-.22.83L6.4 9.48A10.81 10.81 0 0 0 1 18h22a10.81 10.81 0 0 0-5.4-8.52zM7 15.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm10 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z"/>',
        ),
      },
      {
        label: 'Update',
        value: 'Mei 2026',
        icon: statIcon(
          '<path fill="currentColor" d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1zm12 8H5v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8zM7 12h2v2H7v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2z"/>',
        ),
      },
    ],
  },
  intro: [
    'Kadang WhatsApp terasa terlalu terbatas—tidak bisa menyembunyikan status online, tidak ada kontrol privasi yang lebih detail, dan fitur chat juga cukup "itu-itu saja".',
    'Banyak orang akhirnya mencari cara lain lewat WA GB atau GB WhatsApp APK karena ingin lebih bebas mengatur pengalaman chatting mereka.',
    'Setelah mencoba GB WhatsApp Terbaru 2026 v21.30, perbedaan paling terasa ada di kontrol privasi dan fleksibilitas penggunaan. Hal-hal yang sebelumnya tidak bisa dilakukan di WhatsApp resmi, jadi lebih mudah diatur di sini.',
    'Tapi tetap penting untuk memahami risiko sebelum menggunakan WA GB APK sebagai aplikasi utama.',
  ],
};

/** 目录锚点（对应各 H2） */
export const tocSections = [
  { id: 'apa-itu-wa-gb', title: 'Apa itu WhatsApp GB APK?' },
  { id: 'fitur-unggulan', title: 'Fitur Unggulan GB WhatsApp' },
  { id: 'cara-install', title: 'Cara Unduh & Install WA GB APK di Android' },
  { id: 'wa-gb-pc', title: 'WA GB untuk PC' },
  { id: 'panduan-update', title: 'Panduan Update GB WhatsApp Tanpa Kehilangan Chat' },
  { id: 'versi-terbaru', title: 'Versi GB WhatsApp Terbaru' },
  { id: 'perbandingan', title: 'Perbandingan WA GB vs WhatsApp Resmi' },
  { id: 'atasi-ban', title: 'Cara Mengatasi GB WhatsApp Temporary Ban' },
  { id: 'hindari-ban', title: 'Cara Menghindari Ban di WA GB App' },
  { id: 'masalah-umum', title: 'Masalah yang Sering Terjadi di WA GB' },
  { id: 'riwayat-versi', title: 'Riwayat Versi Lama GB WhatsApp Pro' },
  { id: 'faq', title: 'Pertanyaan yang Sering Diajukan (FAQ)' },
];

export const features = [
  {
    title: 'Tema & Kustomisasi Total',
    subtitle: 'Ubah tampilan aplikasi sesuai gaya kamu',
    items: ['Ribuan tema siap pakai', 'Ubah warna, font, bubble chat', 'Custom UI lebih fleksibel'],
  },
  {
    title: 'Privasi Tingkat Lanjut',
    subtitle: 'Kontrol penuh terhadap status online kamu',
    items: ['Sembunyikan "online"', 'Hide "last seen"', 'Matikan centang biru', 'Lihat pesan tanpa ketahuan'],
  },
  {
    title: 'Kirim File Lebih Besar',
    subtitle: 'Batasan pengiriman lebih longgar',
    items: ['Kirim video ukuran besar', 'Kirim banyak foto sekaligus', 'Dukungan format file lebih luas'],
  },
  {
    title: 'Auto Reply Pintar',
    subtitle: 'Otomatisasi pesan lebih mudah',
    items: ['Balasan otomatis', 'Pesan khusus untuk kontak tertentu', 'Cocok untuk bisnis kecil'],
  },
  {
    title: 'Scheduled Message',
    subtitle: 'Kirim pesan sesuai waktu yang kamu tentukan',
    items: ['Jadwalkan pesan ulang tahun', 'Reminder otomatis', 'Support pengiriman massal'],
  },
  {
    title: 'Dual WhatsApp Account',
    subtitle: 'Gunakan 2 akun dalam 1 perangkat',
    items: ['Tidak perlu clone app lain', 'Pisah akun kerja & pribadi', 'Lebih praktis'],
  },
  {
    title: 'Anti Delete Message',
    subtitle: 'Pesan tetap terlihat walau sudah dihapus',
    items: ['Baca pesan yang dihapus pengirim', 'Tidak kehilangan konteks chat'],
  },
  {
    title: 'Download Status',
    subtitle: 'Simpan status teman langsung',
    items: ['Foto & video status', 'Tanpa aplikasi tambahan', '1 klik download'],
  },
  {
    title: 'App Lock Internal',
    subtitle: 'Keamanan tambahan dalam aplikasi',
    items: ['PIN / pattern lock', 'Proteksi chat pribadi', 'Tidak perlu app lock external'],
  },
  {
    title: 'Mode Anti-Ban (Klaim Fitur)',
    subtitle: 'Beberapa versi mengklaim fitur perlindungan akun',
    items: ['Mengurangi risiko deteksi', 'Update anti-ban patch (tidak resmi)'],
  },
  {
    title: 'DND Mode (Do Not Disturb)',
    subtitle: 'Fokus tanpa gangguan',
    items: ['Matikan koneksi WhatsApp saja', 'Tetap online di aplikasi lain'],
  },
  {
    title: 'Broadcast & Message Tools',
    subtitle: 'Fitur komunikasi lebih luas',
    items: ['Broadcast tanpa batasan ketat', 'Tools pengiriman massal', 'Manajemen chat lebih cepat'],
  },
];

export const installSteps = [
  {
    title: 'Download file WA GB APK',
    image: img('content/06-install-step-1-download.webp'),
    items: [
      'Buka browser (Chrome / Firefox)',
      'Cari: "GB WhatsApp APK latest version"',
      'Pilih situs penyedia APK',
      'Klik tombol Download APK',
      'Tunggu hingga file selesai diunduh',
    ],
  },
  {
    title: 'Aktifkan "Sumber Tidak Dikenal"',
    image: img('content/07-install-step-2-unknown-sources.webp'),
    items: [
      'Masuk ke Settings / Pengaturan',
      'Pilih Security / Privasi',
      'Aktifkan Install Unknown Apps / Sumber tidak dikenal',
      'Izinkan browser atau File Manager',
    ],
  },
  {
    title: 'Temukan file APK',
    image: img('content/08-install-step-3-find-apk.webp'),
    items: ['Buka File Manager', 'Masuk ke folder Download', 'Cari file: GBWhatsApp.apk'],
  },
  {
    title: 'Install aplikasi',
    image: img('content/09-install-step-4-install.webp'),
    items: ['Tap file APK', 'Klik Install', 'Tunggu proses instalasi selesai'],
  },
  {
    title: 'Setup akun',
    image: img('content/10-install-step-5-setup.webp'),
    items: [
      'Buka aplikasi GB WhatsApp',
      'Masukkan nomor HP',
      'Verifikasi OTP',
      'Restore chat (jika ada backup)',
    ],
  },
  {
    title: 'Pengaturan tambahan (opsional)',
    image: img('content/11-install-step-6-optional.webp'),
    items: [
      'Matikan Google Play Protect (jika blokir instalasi)',
      'Gunakan nomor kedua untuk keamanan',
      'Backup chat WhatsApp resmi terlebih dahulu',
    ],
  },
];

export const installSection = {
  subtitle:
    'Ikuti langkah-langkah di bawah ini untuk mengunduh dan memasang GB WhatsApp di perangkat Android kamu.',
  noteCard: {
    title: 'Catatan Penting',
    items: [
      'GB WhatsApp bukan aplikasi resmi WhatsApp Inc.',
      'Tidak tersedia di Google Play Store',
      'Risiko keamanan & privasi perlu dipahami',
    ],
  },
  alertCard: {
    title: 'Penting!',
    text:
      'Unduh WA GB APK hanya dari sumber terpercaya. Hindari file modifikasi dari situs tidak jelas agar perangkat dan data chat tetap aman.',
  },
};

export const comparisonRows = [
  {
    feature: 'Fitur privasi',
    gb: 'Lebih fleksibel (sembunyikan status, centang, dll.)',
    official: 'Terbatas dan standar',
  },
  {
    feature: 'Kustomisasi',
    gb: 'Tema, font, tampilan bisa diubah',
    official: 'Tidak mendukung tema',
  },
  {
    feature: 'Fitur tambahan',
    gb: 'Banyak fitur ekstra (auto reply, clone chat, dll.)',
    official: 'Hanya fitur resmi',
  },
  {
    feature: 'Keamanan',
    gb: 'Tidak resmi, tergantung versi',
    official: 'Lebih aman & stabil',
  },
  {
    feature: 'Update',
    gb: 'Manual via APK',
    official: 'Otomatis via Play Store',
  },
];

export const banFixSteps = [
  {
    title: 'Tunggu masa blokir berakhir',
    desc:
      'Temporary ban biasanya berlangsung beberapa jam hingga beberapa hari. Setelah waktu selesai, akun bisa digunakan kembali secara otomatis.',
  },
  {
    title: 'Backup data chat dan media',
    desc:
      'Sambil menunggu, buka pengaturan GB WhatsApp lalu lakukan backup agar semua pesan dan file tetap aman jika perlu reinstall.',
  },
  {
    title: 'Gunakan aplikasi versi terbaru',
    desc:
      'Setelah masa ban berakhir, pastikan kamu memasang WA GB APK atau GB WhatsApp anti ban versi terbaru untuk mengurangi risiko terulang.',
  },
  {
    title: 'Instal ulang aplikasi jika diperlukan',
    desc:
      'Jika masih bermasalah, uninstall versi lama lalu install ulang dari sumber yang terpercaya, kemudian login kembali menggunakan nomor yang sama.',
  },
  {
    title: 'Restore data chat',
    desc: 'Saat login, pilih opsi restore untuk mengembalikan semua percakapan dan media yang sudah dibackup sebelumnya.',
  },
];

export const avoidBanTips = [
  {
    title: 'Selalu gunakan versi terbaru',
    desc:
      'Pastikan kamu memakai WA GB APK versi terbaru atau GB WhatsApp anti ban agar sistem lebih stabil dan sesuai dengan update terbaru.',
  },
  {
    title: 'Hindari terlalu sering mengganti versi',
    desc: 'Sering instal ulang atau berpindah versi dapat memicu ketidaksesuaian data dan meningkatkan risiko deteksi.',
  },
  {
    title: 'Gunakan fitur secara normal',
    desc: 'Hindari aktivitas berlebihan seperti spam, broadcast berlebihan, atau penggunaan otomatis dalam waktu singkat.',
  },
  {
    title: 'Backup data secara rutin',
    desc: 'Backup membantu menjaga semua chat dan media tetap aman jika terjadi error atau perlu reinstall aplikasi.',
  },
  {
    title: 'Gunakan sumber download terpercaya',
    desc: 'Pastikan file WA GB App berasal dari sumber yang stabil agar tidak menggunakan versi yang dimodifikasi secara berbahaya.',
  },
];

export const commonProblems = [
  {
    icon: '🔐',
    title: 'Login Problem',
    desc: 'Tidak bisa verifikasi nomor atau kode OTP tidak masuk.',
    solution:
      'Pastikan nomor aktif, gunakan koneksi stabil, lalu coba login ulang setelah beberapa menit. Jika masih gagal, reinstall WA GB APK versi terbaru.',
  },
  {
    icon: '💬',
    title: 'Chat Loss',
    desc: 'Chat hilang setelah update atau reinstall aplikasi.',
    solution: 'Gunakan fitur backup di GB WhatsApp sebelum update, lalu pilih "restore chat" saat login kembali.',
  },
  {
    icon: '⚠️',
    title: 'Crash / Error',
    desc: 'Aplikasi sering keluar sendiri atau tidak bisa dibuka.',
    solution:
      'Hapus versi lama, install ulang GB WhatsApp anti ban versi terbaru, dan pastikan perangkat memiliki ruang penyimpanan cukup.',
  },
  {
    icon: '🔔',
    title: 'Notification Issue',
    desc: 'Pesan masuk tapi tidak muncul notifikasi.',
    solution: 'Aktifkan izin notifikasi di pengaturan HP dan nonaktifkan battery optimization untuk WA GB App.',
  },
  {
    icon: '📦',
    title: 'Installation Problem',
    desc: 'APK gagal dipasang atau muncul error "App not installed".',
    solution:
      'Hapus versi lama terlebih dahulu, lalu pastikan file WA GB APK kompatibel dengan versi Android perangkat kamu.',
  },
];

export const oldVersions = [
  { version: 'v21.30', date: 'Mei 2026', baseVersion: '2.26.10.72', size: '99 MB', android: 'Android 5.0+' },
  { version: 'v21.25', date: 'Mei 2026', baseVersion: '2.26.10.72', size: '95 MB', android: 'Android 5.1+' },
  { version: 'v24.15', date: 'Rilis Kustom', baseVersion: 'Build Kustom', size: '90 MB', android: 'Android 5.0+' },
  { version: 'v23.00', date: '2026', baseVersion: '2.24.25.70', size: '85 MB', android: 'Android 5.0+' },
  { version: 'v18.80', date: 'Maret 2026', baseVersion: '2.24.25.71', size: '99 MB', android: 'Android 5.0+' },
  { version: 'v18.70', date: 'Februari 2026', baseVersion: '2.24.25.71', size: '99 MB', android: 'Android 5.0+' },
  { version: 'v18.30', date: 'Februari 2025', baseVersion: '2.24.25.71', size: '80 MB', android: 'Android 5.0+' },
  { version: 'v18.20', date: 'Desember 2024', baseVersion: '2.24.25.71', size: '77.2 MB', android: 'Android 5.0+' },
  { version: 'v18.10', date: 'November 2024', baseVersion: '2.24.16.76', size: '77.2 MB', android: 'Android 5.0+' },
  { version: 'v18.00', date: 'Oktober 2024', baseVersion: '2.24.16.76', size: '77.2 MB', android: 'Android 5.0+' },
  { version: 'v17.85', date: 'September 2024', baseVersion: '2.24.16.45', size: '74.4 MB', android: 'Android 5.0+' },
  { version: 'v17.55', date: 'Oktober 2023', baseVersion: '2.23.18.79', size: '70.3 MB', android: 'Android 4.1+' },
  { version: 'v17.20', date: 'Desember 2022', baseVersion: '2.22.24.78', size: '56.5 MB', android: 'Android 4.1+' },
  { version: 'v15.40', date: 'September 2021', baseVersion: '2.21.7.14', size: '45 MB', android: 'Android 4.1+' },
  { version: 'v13.50', date: 'Agustus 2021', baseVersion: '2.21.7.14', size: '45 MB', android: 'Android 4.1+' },
  { version: 'v8.60', date: 'November 2020', baseVersion: '2.20.157', size: '31.3 MB', android: 'Android 4.0.3+' },
];

export const faqItems = [
  {
    q: 'Apakah GB WhatsApp aman digunakan?',
    a: 'GB WhatsApp adalah aplikasi modifikasi, sehingga tidak memiliki dukungan resmi. Penggunaannya bisa berjalan normal, tetapi tetap ada risiko seperti bug atau pemblokiran akun.',
  },
  {
    q: 'Apakah WA GB APK bisa digunakan tanpa ban?',
    a: 'Versi GB WhatsApp anti ban dirancang untuk mengurangi risiko pemblokiran, namun tidak ada jaminan 100% aman karena bukan aplikasi resmi.',
  },
  {
    q: 'Apakah chat bisa hilang saat update?',
    a: 'Chat bisa hilang jika kamu tidak melakukan backup terlebih dahulu. Selalu lakukan backup sebelum update untuk menjaga data tetap aman.',
  },
  {
    q: 'Apakah GB WhatsApp bisa digunakan di PC?',
    a: 'Bisa, melalui emulator Android, perangkat tertaut, atau screen mirroring dari HP ke PC.',
  },
  {
    q: 'Apakah perlu uninstall sebelum update?',
    a: 'Tidak selalu. Beberapa versi bisa di-update langsung, tetapi jika terjadi error sebaiknya reinstall setelah backup.',
  },
  {
    q: 'Apa perbedaan WA GB dengan WhatsApp resmi?',
    a: 'WA GB memiliki fitur tambahan seperti kustomisasi dan privasi lebih fleksibel, sedangkan WhatsApp resmi lebih stabil dan aman.',
  },
];

export const userFeedback = [
  { text: 'Update ke v21.30 lebih smooth, tidak ada lag saat chat.', author: 'Andi, Jakarta' },
  { text: 'Backup berhasil dan semua chat kembali normal setelah update.', author: 'Rina, Surabaya' },
  { text: 'Versi terbaru ini lebih stabil dibanding sebelumnya, bagus untuk penggunaan harian.', author: 'Dimas, Bandung' },
];

const infoIcon = (paths) =>
  `<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#25d366" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`;

/** Apa itu WhatsApp GB APK 模块 */
export const whatIsSection = {
  id: 'apa-itu-wa-gb',
  titlePrefix: 'Apa itu',
  titleHighlight: 'GB WhatsApp APK?',
  paragraphs: [
    '<strong>GB WhatsApp APK</strong> adalah versi modifikasi dari aplikasi WhatsApp resmi yang menawarkan fitur tambahan seperti privasi lebih baik, kustomisasi tema, anti-ban, dan kemampuan mengirim file lebih besar.',
    'Aplikasi ini dikembangkan oleh pihak ketiga dan tidak tersedia di Google Play Store, sehingga pengguna perlu mengunduhnya sebagai file APK. Di dalam ekosistem <strong>WA GB</strong>, versi ini sering dipilih karena pengaturan tampilan dan kontrol percakapan yang lebih fleksibel dibanding WhatsApp resmi.',
  ],
  notice:
    'GB WhatsApp bukan aplikasi resmi dari WhatsApp Inc. dan penggunaan aplikasi pihak ketiga memiliki risiko tertentu yang perlu dipahami sebelum memasang.',
  noticeLabel: 'Catatan Penting:',
  illustration: img('content/04-home-what-is-gb.webp'),
  illustrationAlt: 'Ilustrasi GB WhatsApp APK',
  appInfoTitle: 'Informasi Aplikasi GB WhatsApp',
  appInfoItems: [
    {
      label: 'Nama',
      value: 'WhatsApp GB APK',
      icon: infoIcon('<rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>'),
    },
    {
      label: 'Kategori',
      value: 'Aplikasi pesan modifikasi',
      icon: infoIcon('<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><path d="M7 7h.01"/>'),
    },
    {
      label: 'Basis',
      value: 'WhatsApp',
      icon: infoIcon('<path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85-.637-.637 0 0 0-.83.22l-1.88 3.24a11.43 11.43 0 0 0-8.94 0L5.65 5.67a.643.643 0 0 0-.87-.2c-.28.18-.37.54-.22.83L6.4 9.48A10.81 10.81 0 0 0 1 18h22a10.81 10.81 0 0 0-5.4-8.52zM7 15.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm10 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z"/>'),
    },
    {
      label: 'Fokus penggunaan',
      value: 'Kustomisasi & kontrol fitur',
      icon: infoIcon('<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/>'),
    },
    {
      label: 'Status',
      value: 'Tidak resmi',
      icon: infoIcon('<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>'),
    },
    {
      label: 'Platform',
      value: 'Android',
      icon: infoIcon('<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>'),
    },
  ],
};

export const images = {
  pcHero: img('content/14-pc-hero.webp'),
};

/** 首页导语（支持 HTML 内链） */
export const homeIntro = [
  'Kadang WhatsApp terasa terlalu terbatas—tidak bisa menyembunyikan status online, tidak ada kontrol privasi yang lebih detail, dan fitur chat juga cukup "itu-itu saja".',
  'Banyak orang akhirnya mencari cara lain lewat <a href="/"><strong>WA GB</strong></a> atau GB WhatsApp APK karena ingin lebih bebas mengatur pengalaman chatting mereka.',
  'Setelah mencoba <strong>GB WhatsApp Terbaru 2026 v21.30</strong>, perbedaan paling terasa ada di kontrol privasi dan fleksibilitas penggunaan. Hal-hal yang sebelumnya tidak bisa dilakukan di WhatsApp resmi, jadi lebih mudah diatur di sini.',
  'Tapi tetap penting untuk memahami risiko sebelum menggunakan <strong>WA GB APK</strong> sebagai aplikasi utama.',
];

/** HomeContent 模板中的固定文案 */
export const homeCopy = {
  tocTitle: 'Table of Contents',
  tocMetaSuffix: 'topik panduan',
  pc: {
    intro:
      'WA GB untuk PC memungkinkan pengguna menjalankan GB WhatsApp di komputer untuk pengalaman chatting yang lebih nyaman dengan layar lebih besar. Meskipun aplikasi ini dirancang untuk Android, ada beberapa cara yang bisa digunakan untuk mengaksesnya di PC tanpa mengubah fungsi utama aplikasi.',
    imgAlt: 'GB WhatsApp di komputer',
    methodsHeading: '💻 Cara Menggunakan WA GB di PC',
    methods: [
      {
        title: 'Menggunakan Emulator Android',
        desc: 'Install emulator seperti BlueStacks atau LDPlayer di PC, lalu jalankan file WA GB APK di dalam emulator untuk menggunakan aplikasi seperti di HP.',
      },
      {
        title: 'Perangkat Tertaut (Linked Devices)',
        desc: 'Buka WA GB di ponsel, lalu masuk ke menu perangkat tertaut dan scan QR code melalui browser PC seperti WhatsApp Web.',
      },
      {
        title: 'Screen Mirroring',
        desc: 'Gunakan aplikasi seperti AirDroid atau fitur mirroring lainnya untuk menampilkan layar HP ke PC dan mengontrol WA GB dari komputer.',
      },
    ],
    cta: 'Pelajari Lebih Lanjut untuk PC',
    ctaLink: '/unduh-gb-whatsapp-untuk-pc/',
  },
  update: {
    intro:
      'Proses update <strong>WA GB Pro</strong> sebenarnya bisa dilakukan dengan aman selama data percakapan sudah tersimpan dengan benar sebelumnya. Dengan langkah yang tepat, semua chat, grup, dan file media di WhatsApp GB <strong>anti ban</strong> tetap bisa dipertahankan tanpa harus kehilangan data lama.',
    stepsHeading: 'Langkah-langkah:',
    steps: [
      'Pastikan kamu sudah melakukan backup chat di pengaturan GB WhatsApp',
      'Unduh versi terbaru APK yang sesuai dengan versi sebelumnya',
      'Instal file APK baru tanpa menghapus aplikasi lama (jika memungkinkan)',
      'Buka aplikasi dan lakukan verifikasi nomor',
      'Pilih opsi restore untuk mengembalikan semua chat',
    ],
    noteHeading: 'Catatan Kecil',
    noteText:
      'Pastikan selalu melakukan backup sebelum update untuk menghindari kehilangan data. Gunakan versi WA GB APK yang terpercaya, dan hindari menginstal file dari sumber yang tidak jelas. Selain itu, sebaiknya tetap menggunakan versi yang kompatibel agar GB WhatsApp anti ban berjalan lebih stabil setelah pembaruan.',
  },
  version: {
    titleSuffix: ' v21.30',
    intro:
      'GB WhatsApp v21.30 adalah versi terbaru WA GB APK yang hadir dengan peningkatan stabilitas, performa lebih ringan, dan kompatibilitas yang lebih baik di berbagai perangkat Android. Versi ini dirancang untuk memberikan pengalaman chatting yang lebih lancar dengan fitur tambahan yang lebih lengkap.',
    whatsNewHeading: 'Yang baru di versi ini:',
    whatsNew: [
      'Performa lebih stabil dan respons lebih cepat',
      'Perbaikan bug dari versi sebelumnya',
      'Peningkatan kompatibilitas Android terbaru',
      'Fitur privasi GB WhatsApp anti ban yang lebih optimal',
      'Pengalaman penggunaan lebih halus dan ringan',
    ],
    feedbackHeading: '💬 User Feedback',
    cta: '👉 Unduh WA GB APK v21.30 Sekarang',
    ctaLink: '/unduh-gb-wa/',
  },
  comparison: {
    intro:
      'Banyak pengguna memilih antara WA GB APK dan WhatsApp resmi berdasarkan kebutuhan fitur dan kenyamanan penggunaan. Keduanya memiliki fungsi dasar yang sama untuk chat dan panggilan, tetapi berbeda dalam hal fitur tambahan, fleksibilitas, dan tingkat keamanan.',
    heading: '📊 Perbandingan Utama',
    tableHeaders: {
      feature: 'Fitur',
      gb: 'WA GB APK (GB WhatsApp anti ban)',
      official: 'WhatsApp Resmi',
    },
    notice:
      'GB WhatsApp anti ban memang dirancang untuk mengurangi risiko pemblokiran, tetapi tetap merupakan aplikasi modifikasi.',
  },
  banFix: {
    intro: [
      'Penggunaan GB WhatsApp memiliki risiko pemblokiran akun (ban), yang bisa bersifat sementara maupun permanen. Biasanya hal ini terjadi karena penggunaan versi yang tidak stabil atau aktivitas yang terdeteksi tidak normal.',
      'Jika kamu mengalami masalah ini, ada beberapa langkah yang bisa dilakukan untuk memulihkan akun dan mengamankan data chat kamu.',
    ],
    stepsHeading: 'Langkah yang Bisa Dilakukan',
  },
  avoidBan: {
    intro:
      'Menggunakan WA GB App atau GB WhatsApp memang memberikan fitur yang lebih fleksibel dibandingkan aplikasi resmi, namun tetap ada risiko pemblokiran akun jika tidak digunakan dengan hati-hati. Dengan pola penggunaan yang tepat, risiko ini bisa dikurangi secara signifikan.',
    tipsHeading: 'Cara Penggunaan yang Lebih Aman',
  },
  problems: {
    solutionLabel: 'Solusi:',
    cta: 'Lihat Solusi Lengkap',
    ctaLink: '/wa-gb-solusi-masalah/',
  },
  oldVersions: {
    intro:
      'Bagi pengguna yang ingin mencoba versi lama GB WhatsApp Pro, tersedia berbagai pilihan versi yang bisa disesuaikan dengan kebutuhan perangkat dan kompatibilitas Android. Setiap versi memiliki ukuran, fitur, dan stabilitas yang berbeda.',
    heading: '📊 Daftar Versi Lama',
    tableHeaders: {
      version: 'Versi',
      date: 'Tanggal Rilis',
      baseVersion: 'Versi Dasar',
      size: 'Ukuran File',
      android: 'Android Minimum',
    },
    cta: 'Lihat Semua Versi Lama',
    ctaLink: '/wa-gb-versi-lama/',
  },
};
